/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `PO` - Purchase Order
 * * `PO2` - Purchase Order
 * * `SO` - Sales Order
 * * `SO2` - Sales Order
 * * `A7` - Annex VII
 * * `WTN` - Waste Transfer Note
 * * `GLC` - Green List Contract
 * * `SIN` - Supplier Invoice
 * * `BIN` - Buyer Invoice
 * * `SPL` - Supplier Packing List
 * * `PL` - Packing List
 * * `RPL` - Road Packing List
 * * `WT` - Weighbridge Ticket
 * * `BOL` - Bill Of Lading
 * * `SWB` - Seaway Bill
 * * `WCL` - Waste Carrier's License
 * * `SD` - Self Declaration
 * * `F6` - Form 6
 * * `F9` - Form 9
 * * `COO` - Certificate Of Origin
 * * `SC` - Self Certification
 * * `PSI` - Pre-Shipment Inspection Certificate
 * * `CAR` - Certificate of Chemical Analysis Report
 * * `T2L` - T2L
 * * `VGM` - Verified Gross Mas
 * * `CMR` - Driver CMR
 * * `ED` - Export Declaration
 * * `DN` - Delivery Note
 * * `COA` - Certificate of Analysis
 * * `SLS` - Supplier Loading Schedule
 * * `DPP` - DP Document Pack Cover Sheet
 * * `CI` - Commercial Invoice
 * * `ECF` - Export Collection Form
 * * `DP` - DP Document Pack
 * * `BDP` - Buyer Document Pack
 * * `IN` - Indent
 * * `SP` - Shipping Instructions
 * * `DSP` - Draft Shipping Instructions
 * * `BC` - Booking Confirmation
 * * `IL` - Import License
 * * `CR` - Quality Report
 * * `SCR` - Session Quality Report
 * * `IR` - Inspection Report
 * * `OT` - Other (Hidden)
 * * `OTI` - Other Invoice (Hidden)
 * * `OTA` - Other (Visible to buyer and supplier)
 * * `OTB` - Other Buyer (Visible to buyer)
 * * `OTS` - Other Supplier (Visible to supplier)
 * * `MCR` - Material Claim Report
 */
export type DocumentType = typeof DocumentType[keyof typeof DocumentType];


export const DocumentType = {
  PO: 'PO',
  PO2: 'PO2',
  SO: 'SO',
  SO2: 'SO2',
  A7: 'A7',
  WTN: 'WTN',
  GLC: 'GLC',
  SIN: 'SIN',
  BIN: 'BIN',
  SPL: 'SPL',
  PL: 'PL',
  RPL: 'RPL',
  WT: 'WT',
  BOL: 'BOL',
  SWB: 'SWB',
  WCL: 'WCL',
  SD: 'SD',
  F6: 'F6',
  F9: 'F9',
  COO: 'COO',
  SC: 'SC',
  PSI: 'PSI',
  CAR: 'CAR',
  T2L: 'T2L',
  VGM: 'VGM',
  CMR: 'CMR',
  ED: 'ED',
  DN: 'DN',
  COA: 'COA',
  SLS: 'SLS',
  DPP: 'DPP',
  CI: 'CI',
  ECF: 'ECF',
  DP: 'DP',
  BDP: 'BDP',
  IN: 'IN',
  SP: 'SP',
  DSP: 'DSP',
  BC: 'BC',
  IL: 'IL',
  CR: 'CR',
  SCR: 'SCR',
  IR: 'IR',
  OT: 'OT',
  OTI: 'OTI',
  OTA: 'OTA',
  OTB: 'OTB',
  OTS: 'OTS',
  MCR: 'MCR',
} as const;
